import { render } from "./BodyCard.vue?vue&type=template&id=36913df0"
import script from "./BodyCard.vue?vue&type=script&lang=js"
export * from "./BodyCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__